<!-- 
  Component qui contient les postits supprimés, et permet de les restorer.
  Uniquement visible et utilisable par un animateur
-->

<template>
  <div>
    <transition name="fade">
      <div
        class="bg_queue_new"
        v-if="isDisplayed"
      >
        <h1 class="title_queue">
          <b-icon
            class="queueicon"
            pack="fas"
            icon="trash-alt"
            size="is-small"
          ></b-icon> {{ $t('tooltip.trashcan')}}
        </h1>
        <button
          class="closebutton"
          @click="toggleTrashCan"
        >
          <b-icon
            class=""
            pack="far"
            icon="times-circle"
            size="is-small"
          ></b-icon>
        </button>
        <div class="clearfix"></div>
        <b-table
          class="tablequeue"
          :data="trashedPosts"
          :paginated="false"
          :striped="false"
          :hoverable="true"
        >
          <b-table-column
            custom-key="board.queue.label"
            width="200"
            :label="$t('header.post')"
          >
            <template v-slot:default="props">

              <b-icon
                pack="fas"
                icon="square"
                size="is-small"
                :style="'color:'+props.row.couleur"
              ></b-icon>

              <a
                :href="props.row.link"
                target="_blank"
                v-if="props.row.link"
              >
                <b-icon
                  class="editbutton"
                  pack="fas"
                  icon="link"
                  size="is-small"
                ></b-icon>
              </a>
              <a
                @click="loadImagePopup(url_media+'uploads/brainstorming/medias/'+props.row.media)"
                v-if="props.row.media"
              >
                <b-icon
                  pack="fas"
                  icon="image"
                  size="is-small"
                ></b-icon>
              </a>

              <span id="postText">{{ props.row.contenu }}</span>
            </template>
          </b-table-column>

          <b-table-column
            custom-key="board.queue.sheet"
            width="100"
            :label="$t('board.queue.sheet')"
          >
            <template v-slot:default="props">

              {{ current.sheets.filter(e => e.id === props.row.sheet_id)[0].name }}
            </template>
          </b-table-column>

          <b-table-column
            custom-key="board.queue.publier"
            width="3"
            centered
            :label="$t('header.restore')"
          >
            <template v-slot:default="props">

              <b-tooltip
                position="is-right"
                :label="$t('tooltip.restore')"
              >
                <a @click="restorePost(props.row)">
                  <b-icon
                    pack="fas"
                    icon="arrow-up"
                    size="is-small"
                  ></b-icon>
                </a>
              </b-tooltip>
            </template>
          </b-table-column>
        </b-table>
      </div>
    </transition>
    <template v-if="isChoosingPlace">
      <p class="clickText">{{ $t('overlay.clickText') }}</p>
    </template>
  </div>
</template>

<script>

import VueDraggableResizable from 'vue-draggable-resizable'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')

export default {
  name: 'trashcan',
  components: {
    'VueDraggableResizable': VueDraggableResizable
  },
  data: function () {
    return {
      trashedPosts: [],
      width: 400,
      height: 500,
      y: 40,
      pendingId: null,
      url_media: process.env.URL_MEDIA
    }
  },
  computed: {
    ...mapState({
      currentBoardPostWaiting: 'currentBoardPostWaiting',
      isDisplayed: 'trashcanIsDisplayed',
      current: 'current',
      isChoosingPlace: 'isChoosingPlace',
      postlist: 'trashedBoardPost'

    }),
    x: function () {
      var w = window
      var d = document
      var e = d.documentElement
      var g = d.getElementsByTagName('body')[0]
      var x = w.innerWidth || e.clientWidth || g.clientWidth
      return (x - this.width)
    }
  },
  watch: {
    current: {
      handler: function (val) {
        if (this.current.id !== undefined) {
          this.getTrashedPosts()
          var room = 'Room_Brain_' + this.current.id
          this.$socket.emit('room', room)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //Méthode pour restorer un postit, prend le postit à restorer, met à jour le state après avoir fait sa requete
    async restorePost (post) {
      try {
        let res = await fetch(`${process.env.URL_SSO_API}brainstorming/board/restore`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
          },
          body: JSON.stringify({ postId: post.id, board_id: this.current.id })
        })

        this.trashedPosts = await res.json()
      } catch (error) {

      }
    },
    // Méthode qui recupère tous les postits supprimés, et les stocke dans le state
    async getTrashedPosts () {
      let res = await fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/trashed`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
        }
      })
      this.trashedPosts = await res.json()
    },
    loadImagePopup (mediaURL) {
      this.$parent.ImageModalSrc = mediaURL
      this.$parent.isImageModalActive = true
    },
    toggleTrashCan () {
      this.$store.state.board.trashcanIsDisplayed = !this.isDisplayed
    }
  },
  sockets: {
    connect () {
    },
    disconnect () {
    },
    channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
      if (decodeddata.type === 'UPDATE' && decodeddata.post.etat === 'poubelle') {
        this.trashedPosts.push(decodeddata.post)
      }
    }
  }
}
</script>

<style scoped>
.tablequeue {
  overflow-y: scroll;
  height: inherit;
  z-index: 999999;
  display: contents;
}
.bg_queue {
  background-color: #ffffff;
  opacity: 0.9;
  z-index: 10;
  text-align: left;
  cursor: grab;
  padding-bottom: 5px !important;
  margin: 10% 20px 0 0;
  border: solid 3px #666;
  position: fixed;
  right: 0;
  top: 0;
  width: 50%;
  /* min-width: 500px; */
  height: 65%;
}
.groupPublish {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 90px;
}
.queue_item {
  border: 1px solid white;
  margin: 5px;
  padding: 5px;
  color: white;
}

.left {
  float: left;
}

.right {
  text-align: right;
}

.white {
  color: white;
  text-align: right;
}
.reducedQueue {
  position: fixed;
  right: 0;
  top: 0;
  margin: 7%;
}
.queuebutton {
  width: 60px;
  height: 60px;
  background-color: #4da2e2;
  color: white;
}
.blue {
  background-color: #4da2e2;
}
.badge {
  position: absolute;
  background-color: red;
  border-radius: 50px;
  width: 45px;
  height: 45px;
  color: white;
  font-size: 25px;
  margin: 0 0 50px 50px;
}
.title_queue {
  float: left;
  text-align: left;
  font-size: 22px;
  padding-left: 10px;
  padding-top: 5px;
}
.closebutton {
  cursor: pointer;
  float: right;
  background-color: black;
  border: 0px;
  color: white;
  padding: 8px 8px;
}
.tooltip.is-primary::after {
  background-color: #4da2e2;
}
.clickText {
  color: white;
  margin: auto;
  position: fixed;
  padding: 0 10px;
  top: 49%;
  left: 40%;
  border: 1px solid white;
  cursor: crosshair;
}
</style>
<style>
#postText {
  word-break: break-all;
}

.tablequeue > .table-wrapper {
  height: calc(100% - 33px);
  width: 100%;
  overflow-y: scroll !important;
}
.tablequeue > div > table > thead {
  /*display: none !important;*/
}
.b-checkbox.checkbox input[type="checkbox"]:checked + .check {
  background: #4da2e2
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat center center;
  border-color: #4da2e2;
}

.bg_queue_new {
  background-color: #fff;
  opacity: 0.9;
  z-index: 9;
  text-align: left;
  cursor: grab;
  padding-bottom: 5px !important;
  border: solid 3px #666;
  position: fixed;
  right: 30px;
  top: 105px;
  width: 50%;
  /* min-width: 500px; */
  height: 65%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s, top 1s, right 1s, width 1s, height 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  right: 30px;
  top: 0px;
  width: 0%;
  height: 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/board/TrashCan.vue